module.exports = __webpack_public_path__ + "img/square.ed5cf134.svg";